import { ModalKids } from './ModalKids'
export default ModalKids